import React, { Component } from 'react';
import Worker from 'worker-loader!../workers/animatePath.worker';
import { connect } from 'react-redux'

class AnimatedLogo extends Component {
  constructor(props) {
    super(props);  

    this.state = {}

    this._startPathAnimationLoop = () => {
      if (!this._frameId) {
        this._frameId = window.requestAnimationFrame(this._pathAnimationLoop);
      }
    }

    this._endPathAnimationLoop = () => {
      window.cancelAnimationFrame(this._frameId);
      this._frameId = null;
    }

    this._pathAnimationLoop = () => {
      this.worker.postMessage('update');
      this._frameId = window.requestAnimationFrame(this._pathAnimationLoop);
    }

    this._onReceiveMessage = (e) => {
      if(e.data === 'finishedInitialization') {
        this._startPathAnimationLoop();
      } else {
        this.setState({path: e.data.path});
      }
    }
  }

  componentWillUnmount() {
    if (this.worker) {
      this.worker.removeEventListener('message', this._onReceiveMessage);
      this.worker.terminate();
    }    
    this._endPathAnimationLoop();
  }

  componentDidUpdate(prevProps) {
    if (this.props.characterInitialized !== prevProps.characterInitialized && this.props.characterInitialized) {
        const worker = new Worker();
        worker.postMessage({
          path: 'M5.3 29.4L89.2 35.9 164.4 38.9 139 270.7 117.9 338.2 65.2 363.5 28.3 332.9 39.9 290.7 83.1 241.2 147.1 197.1 195.4 195.2 240.9 209.9 281.1 240 284.9 272.8 261 295.9 222.8 302.3 201.3 274.9 207.6 242.3 240.9 209.9 306 169.1 329 142.2M344.9 322.2L346.9 268.6 342.9 212.2 329 142.2 325.5 90.5 322.6 55.7M457.9 178.2L492.7 154.5 533.8 149.4 560.4 158.3 574.1 201.6 572.9 257.5 553 291 508.5 293.6 490.8 245.9 509.8 218.8 535.8 214.3 647.9 180.1M342.9 212.2L387.7 189.6 426.4 205.2 429.5 256.1 425.6 315.7M535.8 214.3L647.9 180.1M634.4 302.3L646 260.7 647.9 180.1 695.2 169.4 741.6 194.7 739.7 264.6 731.2 309.2M159.1 352.2L236.2 381.8 254.1 437.7 205.7 509.3 167.1 509.6 141.5 465.1 147.7 419.7 238.8 460.5 279.6 512.1 287.2 548.9 224.2 602.5 178.9 608.9 122.5 603.8 71.2 589.7 59.6 552.1 65.1 493.6 76.8 407.9M340 361.7L349.6 420.2M287.2 548.9L340.4 480.2 359 476.5 359.1 528.7 372 585.7 417 600.3 475 598.8 496.1 585.2 513.4 557.4 502.9 534.2 446.7 511 426.9 468.8 447 438.3 475.5 430.9 508.2 465.7M502.9 534.2L560.3 559.4 599.3 562.3 629.8 541.5 641.4 512 611.1 490.4 572.9 470.9 578.2 436.1 598.2 411.9 632.5 410.6 659.3 433 764.9 492.2 808.3 484.6 820.9 449.9 808.3 414 768.2 403.5 718.7 434.1 708.2 488.9 706.8 538.4 724 574.2 766.1 580.5 811.4 561.6M40.5 897.2L38.3 838.7 31.8 768.6 36 691.6 99.2 676.9 175.5 735.9 183.7 785.4 155.4 811.9 121.6 803.3 104.1 770.1 131 734.9 163.7 695.8 186.7 674.3 230.6 672.6 248.9 713.3 252.1 761.9 254.7 823.7 257.3 879.8M466.6 645.6L476.9 717.1 493.8 799.2 515.7 829.4 570.6 837.3M568.6 615L582.3 767 610.6 798.6 645 815.1M799.6 660.6L748.2 645.9 713.5 643.8 678.2 656.1 683.1 698.4 709.3 725.1 737.8 742.8 754.6 780.8 712.5 799.7 664.9 790.4M949.6 674.7L900 642.4 866.1 633.2 839 632.2 799.6 660.7 805 702.3 854.4 724.4 885.1 749.7 862.8 779.2 838.6 796 754.6 780.8M949.6 674.7L984.6 635.7 1016.2 634.8 1031.3 657.9 1033.7 703.9 1013.8 758.8 981.2 779.2 943.3 777.4 925 735.8ZM1105.6 806.1L1110.6 742.8 1109.8 675.4 1081.4 613.8 1031.3 657.9M1263.5 807L1228 779.6 1207.4 642.1 1161.6 634.7 1121.6 647.3 1109.8 675.4M688.5 656.1L588.1 694.4 521.6 713.5 424.4 745.5 390.7 762.4 330 780.8 322.6 828.2 344.8 867.3 394.5 863.5 413.3 820.8 419.9 791.4 406 723.9 354.3 694.4 306.6 711.3 252.1 761.9',
          amplitude: 5,
          frequency: 3,
          precision: 2
        });
        worker.addEventListener('message', this._onReceiveMessage);
        this.worker = worker;
    }
  }
  
  render() {
    const { children } = this.props;
    return (
      <div ref={node => this.svgContainerRef = node}>
        {this.state.path ?
          <svg viewBox={"0 0 1280 900"} className={`${this.props.className}`} role='heading' aria-level='1' aria-labelledby='logo-title'>
            <title id="logo-title">Johan Bisse Mattsson</title>
            <path mask="url(#logoMask)" d={this.state.path} style={{fill:'none',stroke:'var(--color)',strokeWidth:'54px'}} strokeLinejoin="round" strokeMiterlimit="1.5"/>
          </svg>
        :
          children
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    characterInitialized: state.Character.initialized,
  };
};

export default connect(mapStateToProps)(AnimatedLogo);
